const serverError = (error) => {
  if (typeof error === 'string') return {fields: [], message: error};
  if (error === null || typeof error !== 'object' || Object.keys(error).length === 0)
    return {message: 'Unknown server error'};
  if (!!error.text) return {fields: [], message: error.text};
  if (!!error.message) return {fields: [], message: error.message};
  if (!!error.error) return {fields: [], message: error.error};
  if (!!error.detail) return {fields: [], message: error.detail};
  return {
    fields: Object.keys(error),
    origin: error,
    message: Object.values(error)
      .map((val) => {
        if (Array.isArray(val) && val.length > 0) return val[0];
        if (typeof val === 'object' && Object.keys(val).length > 0) return null;
        return val;
      })
      .filter((val) => val !== null && `${val}`.trim().length > 0)
      .join(' '),
  };
};

export default serverError;
